import Link from 'next/link';
import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "PopularCollectionCardstyle__Container",
  componentId: "sc-1gjgr4z-0"
})(["", " background-image:url(", ");@media (max-width:", "){", "}"], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "2rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(206 206 206 / var(--tw-bg-opacity, 1))",
  "backgroundSize": "cover",
  "backgroundRepeat": "no-repeat",
  "paddingLeft": "66px",
  "paddingRight": "66px",
  "paddingTop": "4rem",
  "paddingBottom": "4rem"
}, ({
  $backgroundImg
}) => `${$backgroundImg}`, ({
  theme
}) => theme.breakpoint.md, {
  "paddingLeft": "2.5rem",
  "paddingRight": "2.5rem",
  "paddingTop": "2.5rem",
  "paddingBottom": "2.5rem"
});
export const RecipeImgWrapper = styled.div.withConfig({
  displayName: "PopularCollectionCardstyle__RecipeImgWrapper",
  componentId: "sc-1gjgr4z-1"
})(["", " @media (max-width:", "){", "}"], {
  "display": "grid",
  "width": "348px",
  "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
  "gap": "0.25rem",
  "overflow": "hidden",
  "borderRadius": "0.75rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "width": "278px"
});
export const RecipeItem = styled(Link).withConfig({
  displayName: "PopularCollectionCardstyle__RecipeItem",
  componentId: "sc-1gjgr4z-2"
})(["", " img{", " transition:all 0.25s ease-in-out;&:hover{transform:scale(1.15);transition:all 0.3s ease-in;}}@media (max-width:", "){img{&:hover{transform:scale(1);transition:none;}}}"], {
  "aspectRatio": "1 / 1",
  "width": "100%",
  "cursor": "pointer",
  "overflow": "hidden"
}, {
  "height": "100% !important",
  "width": "100% !important",
  "objectFit": "cover"
}, ({
  theme
}) => theme.breakpoint.md);
export const Title = styled.div.withConfig({
  displayName: "PopularCollectionCardstyle__Title",
  componentId: "sc-1gjgr4z-3"
})(["", ""], {
  "textAlign": "center"
});
export const MenuAmount = styled.div.withConfig({
  displayName: "PopularCollectionCardstyle__MenuAmount",
  componentId: "sc-1gjgr4z-4"
})(["", " color:", ";@media (max-width:", "){", "}"], {
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "fontWeight": "400"
}, ({
  $textColor
}) => `${$textColor ? $textColor : '#FFFFFF'}`, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "1.5rem",
  "lineHeight": "2rem"
});
export const Name = styled.div.withConfig({
  displayName: "PopularCollectionCardstyle__Name",
  componentId: "sc-1gjgr4z-5"
})(["", " color:", ";@media (max-width:", "){", "}"], {
  "marginTop": "0.5rem",
  "whiteSpace": "pre-wrap",
  "fontSize": "74px",
  "fontWeight": "700",
  "lineHeight": "64px"
}, ({
  $textColor
}) => `${$textColor ? $textColor : '#FFFFFF'}`, ({
  theme
}) => theme.breakpoint.md, {
  "marginTop": "0.25rem",
  "fontSize": "45px",
  "lineHeight": "50px"
});